<template>
  <div style="padding:10px;background-color: #F5F5F5;min-height: 100%">

    <Card  :bordered="false" :dis-hover="true" style="margin-bottom:10px;">
      <div style="text-align:left">
        <Row :gutter="16">
          <Col span="15">
            <Button type="primary" @click="modal1=true;detail.day=day;detail.id=null" v-if="power.indexOf(32)!=-1">增加</Button>
            &nbsp;
            <a href="/api/export/outexcel?id=3" v-if="power.indexOf(34)!=-1">导出领取码</a>

          </Col>
          <Col span="4">
            <FenleiSelect @on-change="reload" v-model="serch.fenlei" :multiple="false"></FenleiSelect>
          </Col>
          <Col span="5">
             <Input search enter-button placeholder="输入合集名称、编号搜索" v-model="serch.key"  @on-search="reload"/>
          </Col>
        </Row>
      </div>
    </Card>

    <Card :dis-hover="true">
      <Spin fix v-if="loading"></Spin>
      <el-table :data="list" size="small" style="width: 100%" >
        <el-table-column prop="id" label="编号" width="80" :show-tooltip-when-overflow="true"></el-table-column>
      <el-table-column prop="img" label="合集封面图" :show-tooltip-when-overflow="true">
        <template slot-scope="scope">
          <img :src="'/api/upload/online/'+scope.row.img" style="width:50px;"/>
        </template>
      </el-table-column>
      <el-table-column prop="name" label="合集名称" :show-tooltip-when-overflow="true"></el-table-column>
      <el-table-column prop="easy_note" label="简单简介" :show-tooltip-when-overflow="true"></el-table-column>
      <el-table-column prop="note" label="简介" :show-tooltip-when-overflow="true"></el-table-column>
      <el-table-column prop="day" label="分类" width="100" :show-tooltip-when-overflow="true">
        <template slot-scope="scope">
          <p v-for="item in scope.row.fenleis">{{item.name}}</p>
        </template>
      </el-table-column>
      <el-table-column prop="downCount" label="下载量" :show-tooltip-when-overflow="true"></el-table-column>
      <el-table-column prop="day" label="上传日期" :show-tooltip-when-overflow="true"></el-table-column>
      <el-table-column prop="ctime" label="创建时间" :show-tooltip-when-overflow="true"></el-table-column>

        <el-table-column prop="msg" label="操作" width="180" fixed="right">
          <template slot-scope="scope">
            <a target="_blank" :href="'/api/ziliao/ziliaoFiles/downHeji?id='+scope.row.id">下载文件</a>
            <span v-if="power.indexOf(32)!=-1">
               <cite>|</cite>
                <a @click="edit(scope.row.id)">编辑</a>
            </span>

            <span v-if="power.indexOf(33)!=-1">
               <cite>|</cite>
                <a @click="remove(scope.row.id)">删除</a>
            </span>

          </template>
        </el-table-column>
      </el-table>
    </Card>

    <Card  :bordered="false" dis-hover style="text-align: center;margin-top:10px">
      <Page :total="count" show-total :page="page" @on-page-size-change="limitChange"  show-elevator @on-change="change"  show-sizer :page-size-opts="[10, 30,50,100]"></Page>
    </Card>

    <Modal
      v-model="modal1"
      title="增加或编辑"
      :mask-closable="false"
      @on-ok="save"
      @on-cancel="cancel">
      <Form :label-width="80">
        <FormItem label="封面图" :required="!detail.id">
          <UploadOne v-model="detail.img"></UploadOne>
          图片分辨率：正方形，宽度和高度一致。
          <p style="color: orange" v-if="detail.id">
            你当前正在修改合集信息，封面图若不需修改，可直接忽略此项，若需修改直接选择上传新的封面图即可。
          </p>
        </FormItem>
        <FormItem label="分类" :required="!detail.id">
          <FenleiSelect v-model="fenleis"/>
          <span style="color: orange" v-if="detail.id">
            你当前正在修改合集信息，分类若不需修改，可直接忽略此项，若需修改直接选择修改后的分类即可。
          </span>
        </FormItem>
				<FormItem label="合集名称" required>
					<Input v-model="detail.name"/>
				</FormItem>
				<FormItem label="简单简介" required>
					<Input v-model="detail.easy_note"/>
          一句话介绍，在小程序合集列表页面呈现
				</FormItem>
				<FormItem label="简介" required>
          <JsonInput v-model="detail.note"></JsonInput>
          在合集详情页面展示，可插入图片
				</FormItem>
				<FormItem label="上传日期" required>
          <DateSelect v-model="detail.day"></DateSelect>
				</FormItem>
        <FormItem label="下载量" required>
          <Input type="number" v-model="detail.downCount"></Input>
        </FormItem>
      </Form>
    </Modal>

  </div>
</template>

<script>
  import UploadOne from "../../public/upload/UploadOne";
  import JsonInput from "../common/JsonInput";
  import DateSelect from "../../public/iview/DateSelect";
  import FenleiSelect from "./common/FenleiSelect";
  export default {
    components:{UploadOne,JsonInput,DateSelect,FenleiSelect},
    data(){
      return{
        power:this.$storage.getSession('power'),
        baseUrl:'/api/ziliao/ziliaoHeji/',
        list:[],
        page:1,
        count:0,
        limit:10,
        modal1:false,
        detail:{},
        serch:{
          key:'',
          fenlei:0,
        },
        fenleis:[],
        loading:false,
        day:'',
      }
    },
    methods:{
      reload(){
        this.page = 1;
        this.load();
      },
      load(){
        let that = this;
        let params = [];
        if(this.serch.key){
          params.push('t.name0t.id@like@'+this.serch.key);
        }
        that.loading = true;

        if(!this.serch.fenlei){
          this.serch.fenlei = 0;
        }
        this.$axios.get(this.baseUrl+'findall?page='+this.page+'&limit='
          +this.limit+'&params='+params+'&fenlei='+this.serch.fenlei).then(function(rs){
          that.list = rs.data.data;
          that.count = rs.data.count;
          that.loading = false;
        });
      },
      limitChange(val){
        this.limit = val;
        this.load();
      },
      change(val){
        this.page = val;
        this.load();
      },
      save(){
        let that = this;
        this.detail.fenleis = null;
        let data = Object.assign({}, this.detail);
        this.$axios({url:this.baseUrl+'save?fenleis='+this.fenleis,method:'post',data:this.$qs.stringify(data)}).then(function(rs){
          that.toast(rs.data);
          if(rs.data.success){
            that.detail = {};
            that.$router.go(0);
          }
        });
      },
      edit(id){
        let that = this;
        this.$axios.get(this.baseUrl+'getById?id='+id).then(function(rs){
          that.detail = rs.data;
          that.modal1 = true;
        });
      },
      remove(id){
        this.$Modal.confirm({
          title: '系统提示',
          content: '确定要删除吗',
          onOk: () => {
            let that = this;
            this.$axios.get(this.baseUrl+'delete?ids='+id).then(function(rs){
              that.toast(rs.data);
            });
          },
        });
      },
      toast(data){
        if(data.success){
          this.load();
          this.$Message.success(data.msg);
        }else{
          this.$Message.error(data.msg);
        }
      }
    },
    created(){
      this.day = this.getTime().substring(0,10);
      this.load();
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/ziliao/ZiliaoHeji.vue